export type ToastDurationPreset = 'slow' | 'normal' | 'fast'

export const ToasterDuration = {
  SLOW: 'slow',
  NORMAL: 'normal',
  FAST: 'fast',
} as const satisfies Record<string, ToastDurationPreset>

export interface Toaster {
  id: string
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  duration?: ToastDurationPreset | number
}

export const ToasterType = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
} as const
export type ToasterTypeValues = (typeof ToasterType)[keyof typeof ToasterType]

export interface ToasterState {
  toasters: Toaster[]
}
